
export function loadScriptConditionally(url, cond = null){
    return new Promise((resolve, reject) => {
        if(cond){
            resolve(loadScript(url));
        } else {
            resolve(true);
        }
    });

}
export function loadScript(url) {
    return new Promise((resolve, reject) => {
        let script = document.createElement('script');
        script.src = url;                
        document.head.appendChild(script);

        script.onload = function () {
            resolve(true);
        };
    });
}



// WEBPACK FOOTER //
// ./src/helpers/scripts.js